import { MAX_GRADE, MIN_GRADE, bandForGrade } from "./vocab.js";
/**
 * A child tells us their grade once, at sign-up. We never ask again — the grade
 * rolls forward on its own every school year. Storing `enrolledGrade` plus the
 * date we were told beats storing a mutable grade, because it can't go stale and
 * needs no scheduled job.
 *
 * The school year is taken to turn over on 1 August. That is wrong for the
 * southern hemisphere and for a few districts; when this ships outside one
 * region, move the rollover month onto the parent account.
 */
const SCHOOL_YEAR_ROLLOVER_MONTH = 7; // 0-indexed: July index 6, so 7 is August.
export function schoolYearOf(date) {
    const year = date.getUTCFullYear();
    return date.getUTCMonth() >= SCHOOL_YEAR_ROLLOVER_MONTH ? year : year - 1;
}
/** The grade a child is in today, given what they told us when they signed up. */
export function gradeNow(enrolledGrade, enrolledAt, now = new Date()) {
    const yearsElapsed = schoolYearOf(now) - schoolYearOf(enrolledAt);
    const grade = enrolledGrade + Math.max(0, yearsElapsed);
    return Math.min(MAX_GRADE, Math.max(MIN_GRADE, grade));
}
export function bandNow(enrolledGrade, enrolledAt, now = new Date()) {
    return bandForGrade(gradeNow(enrolledGrade, enrolledAt, now));
}
export function gradeLabel(grade) {
    return grade === 0 ? "Kindergarten" : `Grade ${grade}`;
}
//# sourceMappingURL=grade.js.map